import setupAxios from './setup-axios';

export default function API() {
  const axiosConfig = {
    baseURL: process.env.LEARNER_DATA_ITL_API_URL
  };

  const axios = setupAxios(axiosConfig);

  const api = {
    // TODO: remove it?
    removeUserWords(userWordIds) {
      return axios.delete('/user_words/bulk_remove', { data: { user_word_ids: userWordIds } })
        .then(({ data }) => data);
    },

    knownForMediaItem(mediaItemId, item) {
      const params = { mediaitem_id: mediaItemId, item };

      return axios.post('/known_words/known_for_mediaitem', params)
        .then(({ data }) => data);
    },

    unknownForMediaItem(mediaItemId, item) {
      const params = { mediaitem_id: mediaItemId, item };

      return axios.delete('/known_words/unknown_for_mediaitem', { data: params })
        .then(({ data }) => data);
    },

    knownSingleDefinitionForMediaItem(dictionaryWordId, mediaItemId) {
      const params = { mediaitem_id: mediaItemId };

      return axios.post(`/known_words/${dictionaryWordId}/known_for_mediaitem`, params)
        .then(({ data }) => data);
    },

    unknownSingleDefinitionForMediaItem(dictionaryWordId, mediaItemId) {
      const params = { mediaitem_id: mediaItemId };

      return axios.delete(`/known_words/${dictionaryWordId}/unknown_for_mediaitem`, { data: params })
        .then(({ data }) => data);
    },

    // TODO: remove it?
    fetchWords(params) {
      return axios.get('/user_words', { params })
        .then(({ data }) => data);
    },

    // common word list //
    addToKnownFromCommonWordList(dictionaryWordIds) {
      const params = { dictionary_word_ids: dictionaryWordIds };

      return axios.post('/common_word_lists/add_to_known', params, { withCredentials: true })
        .then(({ data }) => data);
    },

    addToWordListFromCommonWordList(dictionaryWordIds, selectedWordListId) {
      const params = {
        dictionary_word_ids: dictionaryWordIds,
        selected_word_list_id: selectedWordListId
      };

      return axios.post('/common_word_lists/add_to_word_list', params, { withCredentials: true })
        .then(({ data }) => data);
    },
    // end common word list //

    // suggested word list
    canBeOpenedSuggestedWordList() {
      return axios.get('/suggested_word_lists/can_be_opened')
        .then(({ data }) => data);
    },

    addToKnownFromSuggestedWordList(dictionaryWordIds) {
      const params = { dictionary_word_ids: dictionaryWordIds };

      return axios.post('/suggested_word_lists/add_to_known', params, { withCredentials: true })
        .then(({ data }) => data);
    },

    addToWordListFromSuggestedWordList(dictionaryWordIds, selectedWordListId) {
      const params = {
        dictionary_word_ids: dictionaryWordIds,
        selected_word_list_id: selectedWordListId
      };

      return axios.post('/suggested_word_lists/add_to_word_list', params, { withCredentials: true })
        .then(({ data }) => data);
    },

    // form drag-n-drop sync
    addKnownWord({ dictionary_word_id, text, mediaitem_id, translation_language_id, fragment }) {
      const params = {
        original_word: text,
        mediaitem_id,
        translation_language_id,
        fragment
      };

      return axios.post(`/known_words/${dictionary_word_id}`, params)
        .then(({ data }) => {
          window.hj && window.hj('tagRecording', ['add_known_word', params.mediaitem_id]);

          return data;
        });
    },

    // form drag-n-drop sync
    removeKnownWord(dictionaryWordId, mediaItemId = null) {
      const params = {
        mediaitem_id: mediaItemId
      };

      return axios.delete(`/known_words/${dictionaryWordId}`, { data: params })
        .then(({ data }) => data);
    },

    addWordToList(word, wordListId) {
      const params = {
        word,
        word_list_id: wordListId
      };

      return axios.post('user_words/add_to_word_list', params)
        .then(({ data }) => {
          window.hj && window.hj('tagRecording', ['add_word_to_list', word.mediaitem_id]);

          return data;
        });
    },

    broadcastKnownWords(dictionaryWordId, mediaItemId) {
      const params = {
        dictionary_word_id: dictionaryWordId,
        mediaitem_id: mediaItemId
      };

      return axios.post('/known_words/broadcast', params)
        .then(({ data }) => data);
    }
  };

  return api;
}
